// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { initializeAuthToken } from "../utilities/parameterStore"
import {logger} from 'redux-logger'

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    process.env.NODE_ENV !== 'production'
      ? getDefaultMiddleware({
        serializableCheck: false
      }).concat(logger)
      : getDefaultMiddleware({
        serializableCheck: false
      }),
  devTools: process.env.NODE_ENV !== 'production',
});

initializeAuthToken(store);

export default store;
